module.exports = __webpack_public_path__ + "a8daf77a1bd7980cd1845742d5a1ab51.png";